import React from "react";
import _ from "lodash";
import { notify } from "react-notify-toast";
import { VseAPI } from "apis";
import VSEPageWrapper from "./VSEPageWrapper";
import DateTimeFormatter from "../common/DateTimeFormatter";
import PopupWrapper from "../common/PopupWrapper";
import RecipeBox from "./recipe/RecipeBox";
import ReactTooltip from "react-tooltip";
import ModalWrapper from "../common/ModalWrapper";
import VSECheckBox from "./VSECheckbox";

class ExecutionsViewer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      errMsg: null,

      data: null,

      selectedItems: [],
      isModalOpen: false,
      isSaving: false,
      saveErrMsg: null,
    };

    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.handleSelectItem = this.handleSelectItem.bind(this);
    this.handleClearAll = this.handleClearAll.bind(this);
    this.handleResetClicked = this.handleResetClicked.bind(this);

    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleConfirmReset = this.handleConfirmReset.bind(this);
  }

  async componentDidMount() {
    const networkId = _.get(this.props, "networkId");

    if (networkId) {
      document.title = `E: ${networkId} | VSE Executions`;
    }

    await this._queryAndUpdateUI({ networkId: _.parseInt(networkId) });
  }

  async _queryAndUpdateUI(params) {
    this.setState({ isLoading: true });
    try {
      const { items, networkInfo } = await this.queryData(params);

      if (_.isEmpty(items)) {
        return this.setState({ errMsg: "No executions found" });
      }

      this.setState({
        data: items,
        networkInfo,
      });
    } catch (err) {
      console.log("Error querying vse executions", err);
    }
    this.setState({ isLoading: false });
  }

  async queryData(params) {
    const { executions, networkInfo } = await VseAPI.getVSEExecutionsByNetwork(
      params
    );
    const { recipes } = this.props;
    const recipesByIdVersion = _.keyBy(recipes, (r) => `${r.id}_${r.version}`);
    // console.log(executions);
    // console.log(recipes);

    const items = _.map(executions, (exe) => {
      exe.key = `${exe.recipe_id}_${exe.version}`;
      exe.recipe = recipesByIdVersion[exe.key];
      return exe;
    });

    return { items, networkInfo };
  }

  handleSelectAll() {
    const { selectedItems, data } = this.state;
    if (selectedItems.length === data.length) {
      this.setState({
        selectedItems: [],
      });
    } else {
      this.setState({ selectedItems: _.map(data, "recipe_id") });
    }
  }

  handleSelectItem(recipeId) {
    const { selectedItems } = this.state;

    if (_.indexOf(selectedItems, recipeId) === -1) {
      this.setState({
        selectedItems: [...selectedItems, recipeId],
      });
    } else {
      const newSelectedItems = selectedItems;
      _.pull(newSelectedItems, recipeId);
      this.setState({ selectedItems: newSelectedItems });
    }
  }

  handleClearAll() {
    this.setState({ selectedItems: [] });
  }

  handleResetClicked() {
    this.setState({ isModalOpen: true });
  }

  handleModalClose() {
    this.setState({ isModalOpen: false });
  }

  async handleConfirmReset() {
    const params = {
      networkId: this.props.networkId,
      recipeIds: this.state.selectedItems,
    };

    this.setState({ isSaving: true });

    try {
      const { result } = await VseAPI.resetVSEExecutions(params);
      if (result.op === "ok") {
        notify.show("Reset successful! Reloading page...", "success");
        setTimeout(() => {
          window.location.reload(false);
        }, 3000);
      } else {
        throw `Failed response: ${JSON.stringify(result)}`;
      }
    } catch (err) {
      this.setState({ saveErrMsg: err });
    }

    this.setState({ isSaving: false });
  }

  render() {
    const {
      isLoading,
      errMsg,
      networkInfo,
      data,
      selectedItems,
      isModalOpen,
      isSaving,
      saveErrMsg,
    } = this.state;

    return (
      <VSEPageWrapper
        isLoading={isLoading}
        errMsg={errMsg}
        networkInfo={networkInfo}
      >
        {data && (
          <div>
            <div className="text-lg font-semibold">
              {data && data.length} Executions
            </div>
            <ExecutionsTable
              items={data}
              selectedItems={selectedItems}
              handleSelectAll={this.handleSelectAll}
              handleSelectItem={this.handleSelectItem}
            ></ExecutionsTable>

            <ActionFooter
              selectedItems={selectedItems}
              handleClearAll={this.handleClearAll}
              handleResetClicked={this.handleResetClicked}
            ></ActionFooter>

            <ModalWrapper
              isOpen={isModalOpen}
              handleClose={this.handleModalClose}
              width="60%"
              showCloseFooter={false}
              title={`Reset the following recipes (${selectedItems.length}):`}
            >
              <div>
                <div>
                  <table className="border shadow table w-full text-sm">
                    <thead className="border-b bg-gray-200 text-xs text-blue-800">
                      <tr>
                        <th className="border px-2 py-2">Recipes</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white font-mono text-gray-900">
                      {selectedItems &&
                        selectedItems.map((recipeId) => {
                          const r = _.find(data, { recipe_id: recipeId });
                          return (
                            <tr
                              key={recipeId}
                              className="border-b hover:bg-gray-100"
                            >
                              <td className="whitespace-no-wrap border px-2 py-2 font-sans font-semibold">
                                <RecipeView recipe={r.recipe}></RecipeView>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>

                <div className="mt-4 flex flex-row-reverse items-center">
                  <div>
                    <button
                      type="button"
                      className="rounded shadow bg-blue-500 px-4 py-2 font-semibold text-white hover:bg-blue-700"
                      onClick={this.handleConfirmReset}
                    >
                      {isSaving ? "Saving..." : "Confirm reset"}
                    </button>
                  </div>
                  <div>
                    <button
                      type="button"
                      disabled={isSaving}
                      className={`px-4 py-2 text-blue-700 ${
                        isSaving ? "cursor-not-allowed" : ""
                      }`}
                      onClick={this.handleModalClose}
                    >
                      Cancel
                    </button>
                  </div>
                  <div className="text-red-600">{saveErrMsg}</div>
                </div>
              </div>
            </ModalWrapper>
          </div>
        )}
      </VSEPageWrapper>
    );
  }
}

const ExecutionsTable = (props) => {
  const { items, selectedItems, handleSelectAll, handleSelectItem } = props;

  const sortedItems = _sortItems(items);

  function _sortItems(items) {
    return _.orderBy(items, [_sort], ["desc"]);
  }

  function _sort(item) {
    return item.next_execution_at;
  }

  return (
    <div>
      <table
        className="border shadow table w-full text-sm"
        style={{ marginBottom: "500px" }}
      >
        <thead className="border-b bg-gray-200 text-xs text-blue-800">
          <tr>
            <th>
              <div className="w-12">
                <VSECheckBox
                  isChecked={selectedItems.length === items.length}
                  handleClick={handleSelectAll}
                ></VSECheckBox>
              </div>
            </th>
            <th className="border px-2 py-2">Recipe</th>
            <th className="border px-2 py-2">Last execution at</th>
            <th className="border px-2 py-2">Next execution at</th>
          </tr>
        </thead>
        <tbody className="bg-white font-mono text-gray-900">
          {items &&
            sortedItems.map((r) => {
              return (
                <tr key={r.key} className="border-b hover:bg-gray-100">
                  <td className="w-12 text-center">
                    <VSECheckBox
                      isChecked={selectedItems.indexOf(r.recipe_id) !== -1}
                      handleClick={() => handleSelectItem(r.recipe_id)}
                    ></VSECheckBox>
                  </td>
                  <td className="whitespace-no-wrap border px-2 py-2 font-sans font-semibold">
                    <RecipeView recipe={r.recipe}></RecipeView>
                  </td>
                  <td className="whitespace-no-wrap border px-3 py-1 text-left">
                    <DateTimeFormatter
                      datetime={r.last_execution_at}
                    ></DateTimeFormatter>
                  </td>
                  <td className="whitespace-no-wrap border px-3 py-1 text-left">
                    <DateTimeFormatter
                      datetime={r.next_execution_at}
                    ></DateTimeFormatter>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

const RecipeView = (props) => {
  const { recipe } = props;
  // id
  // version
  // name
  // ...

  return (
    <>
      <PopupWrapper
        place="bottom left"
        hideArrow={true}
        triggerElement={
          <div className="rounded border cursor-pointer bg-gray-200 px-2">
            {recipe.id} - {recipe.name}
          </div>
        }
        popupElement={
          <div
            className="overflow-y-auto border-4 border-gray-600 shadow-lg"
            style={{ marginTop: "-9px", maxHeight: "500px" }}
          >
            <RecipeBox item={recipe}></RecipeBox>
          </div>
        }
      ></PopupWrapper>
    </>
  );
};

const ActionFooter = (props) => {
  const { selectedItems, handleClearAll, handleResetClicked } = props;
  return (
    <div className="fixed bottom-0 left-0 w-full border-t-2 bg-white px-4 py-2">
      <div className="flex items-center gap-2 text-gray-700">
        <div className="w-48 text-right text-sm">
          Selected Recipes ({selectedItems.length}):
        </div>
        <textarea
          rows="1"
          value={selectedItems.join(", ")}
          readOnly
          className="border rounded w-full p-1 text-xs"
        ></textarea>
        <div className="flex items-center gap-4">
          <button
            className="rounded overflow-x-auto bg-blue-200 px-2 py-1 text-sm font-semibold text-blue-900 hover:bg-blue-300"
            type="button"
            data-tip
            data-for="reset-recipes-button"
            onClick={handleResetClicked}
            disabled={selectedItems.length === 0}
          >
            Reset
          </button>
          <ReactTooltip id="reset-recipes-button" type="dark" effect="solid">
            See reset recipes in preview
          </ReactTooltip>
          <button
            className="rounded overflow-x-auto px-4 py-1 text-sm text-blue-600 hover:bg-blue-100"
            type="button"
            onClick={handleClearAll}
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExecutionsViewer;
